import { getExpandingWildAction } from 'automaton/actions/ExpandingWildAction'
import { getWinBigAction } from 'automaton/actions/WinBigAction'
import { getWinMultiplyAction } from 'automaton/actions/WinMultiplyAction'
import { getWinSmallAction } from 'automaton/actions/WinSmallAction'
import { getAutoRespinState } from 'automaton/states/AutoRespinState'
import { getAutoState } from 'automaton/states/AutoSpinState'
import { getBetState } from 'automaton/states/BetState'
import { getFreespinAddState } from 'automaton/states/FreespinsAddState'
import { AutoSpinManager } from 'managers/AutoSpinManager'

export function getAutoWinState() {
  const winModel = game.models.WinModel.get()
  const freespinModel = game.models.FreespinModel.get()
  const spinModel = game.models.SpinModel.get()

  const name = 'WIN'
  const actions = [
    getExpandingWildAction(),
    winModel.winType == 'regular'
      ? getWinSmallAction(false)
      : getWinBigAction(),
    getWinMultiplyAction(),
  ]
  const transition = () => spinModel.respin.length
    ? getAutoRespinState()
    : freespinModel.add
      ? getFreespinAddState(false)
      : AutoSpinManager.isAllowed()
        ? getAutoState()
        : getBetState()

  return {
    name,
    actions,
    transition,
  }
}
